var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.cart && _vm.cart.counts > 0
    ? _c("a", { staticClass: "fixed-cart", attrs: { href: "/cart/" } }, [
        _c("i", { staticClass: "bi bi-bag-plus fixed-cart__icon" }),
        _vm._v(" "),
        _c("span", { staticClass: "fixed-cart__counts" }, [
          _vm._v(_vm._s(_vm.cart.counts)),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }